import { render, staticRenderFns } from "./PatientTable.vue?vue&type=template&id=50b5c848&lang=pug"
import script from "./PatientTable.vue?vue&type=script&lang=js"
export * from "./PatientTable.vue?vue&type=script&lang=js"
import style0 from "./PatientTable.vue?vue&type=style&index=0&id=50b5c848&prod&lang=scss"
import style1 from "./PatientTable.vue?vue&type=style&index=1&id=50b5c848&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports